import { ConditionalTooltip } from "components/ConditionalTooltip";
import { IconText } from "components/IconText";
import { GlobalContext } from "contexts/GlobalContext";
import { useCopyStory } from "hooks/useCopyStory";
import { useCallback, useContext } from "react";
import { CompletedGamePlayerStateResult } from "results/frankenstories/CompletedGamePlayerStateResult";
import { GetGameStateResult } from "results/frankenstories/GetGameStateResult";

export const CopyStoryButton = (props: {
    gameState: GetGameStateResult;
    playerState?: CompletedGamePlayerStateResult;
}) => {
    const { gameState, playerState } = props;

    const { addNotification } = useContext(GlobalContext);

    const { copiedStory } = useCopyStory({ gameState });

    const copyStory = useCallback(() => {
        if (copiedStory) {
            navigator.clipboard.writeText(copiedStory);

            // show toast
            addNotification({
                title: "Text copied",
                description: "Now go paste it somewhere!",
                type: "success",
            });
        }
    }, [addNotification, copiedStory]);

    const copyMyReplies = useCallback(() => {
        if (playerState?.playerReplies) {
            let story = "";

            for (const s of playerState?.playerReplies) {
                story += `${s.name}   
                            
${s.description}

`;
            }

            navigator.clipboard.writeText(story);

            // show toast
            addNotification({
                title: "Your replies copied",
                description: "Now go paste it somewhere!",
                type: "success",
            });
        }
    }, [addNotification, playerState?.playerReplies]);

    if (playerState?.isPlayer && playerState.playerReplies?.length) {
        return (
            <ConditionalTooltip show={true} text="Copy story" placement="top">
                <div className="dropdown">
                    <button type="button" className="btn btn-dark btn-circle" data-bs-toggle="dropdown">
                        <span className="fal fa-copy"></span>
                    </button>

                    <ul className="dropdown-menu">
                        <li>
                            <button type="button" className="dropdown-item" onClick={copyStory}>
                                <IconText icon="fas fa-copy" text="Copy final text" />
                            </button>
                        </li>
                        <li>
                            <button type="button" className="dropdown-item" onClick={copyMyReplies}>
                                <IconText icon="fas fa-user" text="Copy my replies" />
                            </button>
                        </li>
                    </ul>
                </div>
            </ConditionalTooltip>
        );
    }

    return (
        <button type="button" className="btn btn-dark btn-circle" onClick={copyStory}>
            <span className="fal fa-copy"></span>
        </button>
    );
};
